// @ts-nocheck

async function AddToCart(payload, productId) {
  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      items: payload,
    }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.description || "Failed to add to cart");
  }

  const cartResponse = await fetch("/cart.js");
  //const cart = await cartResponse.json();

  //cartUpdate(cart.item_count, productId);
}

function cartUpdate(quantity, productId= '') {
  const cartAddEvent = new CustomEvent("cart:update", {
    bubbles: true,
    detail: {
      resource: {
        item_count: quantity,
      },
      data: {
        didError: false,
        itemCount: quantity,
        productId: productId,
      },
    },
  });

  document.dispatchEvent(cartAddEvent);
  setTimeout(()=>{
    openCartDrawer()
  }, 1000)
}

function openCartDrawer(){
  const cartDrawer = document.querySelector('cart-drawer-component');
  if (cartDrawer && typeof cartDrawer.open === 'function') {
    cartDrawer.open();
    return;
  }

  // Fallback: click the header cart trigger (if present)
  const cartTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
  if (cartTrigger && typeof cartTrigger.click === 'function') {
    cartTrigger.click();
  }

}
